/**
 * The library is 48 kHz throughout, and most output devices run at 48 kHz, so
 * pinning the graph there avoids resampling on decode and on output.
 */
const SAMPLE_RATE = 48000;

let ctx: AudioContext | undefined;

export function audioContext(): AudioContext {
  if (!ctx) {
    ctx = new AudioContext({ sampleRate: SAMPLE_RATE, latencyHint: "interactive" });
  }
  return ctx;
}

/**
 * Browsers start an AudioContext suspended until a user gesture. Every path
 * that starts sound must go through here first.
 */
export async function ensureRunning(): Promise<AudioContext> {
  const context = audioContext();
  if (context.state === "suspended") {
    await context.resume();
  }
  return context;
}
